import generatePDF from "react-to-pdf";
import { useRef, forwardRef, useImperativeHandle } from "react";

export const ContainerRenderToPDF = forwardRef(
  ({ filename, orientation, children, sx }, ref) => {
    const targetRef = useRef();
    const getTargetElement = () => targetRef.current;

    const handleRenderPDF = async () => {
      if (targetRef.current) {
        const options = {
          filename,
          page: {
            margin: 10,
            orientation,
          },
        };

        generatePDF(getTargetElement, options);
      }
    };

    useImperativeHandle(ref, () => ({
      renderPDF: handleRenderPDF,
      getElement: () => targetRef.current, // expõe o DOM real
    }));

    return (
      <div style={sx} ref={targetRef}>
        {children}
      </div>
    );
  }
);
